import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { Text } from "components/Texts";

const Alert = ({ children }) => {
  return (
    <StyledContainer>
      {typeof children === "object" ? children : <Text color="#ff4848">{children}</Text>}
    </StyledContainer>
  );
};

Alert.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Alert;

const StyledContainer = styled.div`
  border: 1px solid #ffb5b5;
  padding: 8px;
  border-radius: 4px;
  background-color: #ffe3e3;
  margin: 0 0 16px;
  text-align: center;
  color: #ff4848;
`;
